var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-wrapper"},[_c('riskhub-vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":true}}),(_vm.terms.length > 0)?_c('div',{staticClass:"terms",domProps:{"innerHTML":_vm._s(_vm.terms)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }